import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '30vh',
    background: `url(${process.env.PUBLIC_URL}/images/contactimage_moreearth.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      height: '50vh',
      backgroundPosition: 'center',
    }
  },
}));

export default function HeadSection() {
  const classes = useStyles()
  return (
    <Fragment>            
      <div className={classes.wrapper} />
    </Fragment>
  );
}
